module.exports = __webpack_public_path__ + "img/digital_signage.2c32c287.png";